<template>
    <div>
        <el-form @submit.native.prevent="onSubmitExclusao" :model="dados" ref="dados" label-position="top">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <dl>
                        <dt>NOME</dt>
                        <dd>{{ servidor.nome }}</dd>
                    </dl>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8">
                    <dl>
                        <dt>CÓD. DO SERVIDOR</dt>
                        <dd>{{ servidor.id }}</dd>
                    </dl>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="8" :md="8">
                    <dl>
                        <dt>CPF</dt>
                        <dd>{{ servidor.cpf ? servidor.cpf : '-' }}</dd>
                    </dl>
                </el-col>
                <el-col :xs="24" :sm="16" :md="16">
                    <dl>
                        <dt>FILIAÇÃO 1</dt>
                        <dd>{{ servidor.mae ? servidor.mae : '-' }}</dd>
                    </dl>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mt-30">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Ação" prop="acao" :rules="[$requiredChange]" key="acao">
                        <el-select v-model="dados.acao" clearable>
                            <el-option :key="1" label="EXCLUIR" :value="1"></el-option>
                            <el-option :key="2" label="UNIFICAR" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="dados.acao == 2">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Cód. do servidor destino" prop="servidor_destino_id" :rules="[$requiredBlur]" key="servidor_destino_id">
                        <el-input v-model="dados.servidor_destino_id" maxlength="20" v-mask="'##########'" placeholder="Informe o código do servidor que receberá as lotações"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10" v-if="dados.acao">
                <el-col :xs="24" :sm="18" :md="18" v-if="dados.acao == 2">
                    <i>Informe o código do servidor que receberá as lotações e enturmações. O servidor atual será excluído.</i>
                </el-col>
                <el-col :xs="24" :sm="dados.acao == 2 ? 6 : 24" :md="dados.acao == 2 ? 6 : 24">
                    <el-form-item class="u-text-right">
                        <el-button type="primary" id="btn-exclusao-servidor" native-type="submit">{{ dados.acao == 1 ? 'EXCLUIR' : 'UNIFICAR' }}</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['servidor'],
    data: () => ({
        dados: {
            servidor_id: '',
            acao: '',
            servidor_destino_id: ''
        }
    }),
    mounted () {
        this.dados.servidor_id = this.servidor.id;
    },
    methods: {
        onSubmitExclusao () {
            this.$refs.dados.validate((valid) => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' });
                    return;
                }

                window.eventBus.$emit('loading', true);

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/servidor/unificarServidor`, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);

                    if (typeof response.data.erro !== 'undefined') {
                        window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' });
                        return;
                    }

                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' });
                    this.$emit('closeModal');

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            });
        }
    }
}
</script>
